interface PlanPaymentProps {
    onComplete: () => void;
    onBack: () => void;
}

const PlanPayment: React.FC<PlanPaymentProps> = ({ onComplete, onBack }) => {
    return (
        <div className="
            flex flex-col gap-5
            my-5 mx-auto
            w-[calc(60%-40px)]
            bg-white dark:bg-gray-900
            p-5
        ">
            {/* Payment Info */}
            <div>
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
                    Thông tin chuyển khoản
                </h2>

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                    {/* Bank Info Section */}
                    <div className="lg:col-span-2 bg-gradient-to-br from-blue-50/50 to-white dark:from-gray-800 dark:to-gray-900 border border-blue-100 dark:border-gray-700 rounded-2xl p-6 space-y-3">
                        {/* Bank Name */}
                        <div className="bg-white dark:bg-gray-800 rounded-xl p-4">
                            <span className="text-xs text-gray-500 dark:text-gray-400 block mb-1">
                                Ngân hàng
                            </span>
                            <span className="font-semibold text-gray-900 dark:text-white text-sm">
                                Ngân hàng TMCP Á Châu (ACB)
                            </span>
                        </div>

                        {/* Account Number */}
                        <div className="bg-white dark:bg-gray-800 rounded-xl p-4 flex justify-between items-center">
                            <div className="flex-1">
                                <span className="text-xs text-gray-500 dark:text-gray-400 block mb-1">
                                    Số tài khoản
                                </span>
                                <span className="font-mono font-bold text-gray-900 dark:text-cyan-400 text-lg">
                                    123456789
                                </span>
                            </div>
                            <button
                                type="button"
                                title="Sao chép số tài khoản"
                                aria-label="Sao chép số tài khoản"
                                className="ml-3 p-2 hover:bg-blue-50 dark:hover:bg-gray-700 rounded-lg transition-colors"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5 text-gray-400 dark:text-gray-500">
                                    <rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect>
                                    <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path>
                                </svg>
                            </button>
                        </div>

                        {/* Account Holder */}
                        <div className="bg-white dark:bg-gray-800 rounded-xl p-4">
                            <span className="text-xs text-gray-500 dark:text-gray-400 block mb-1">
                                Chủ tài khoản
                            </span>
                            <span className="font-semibold text-gray-900 dark:text-white text-sm">
                                CONG TY TNHH ABC
                            </span>
                        </div>

                        {/* Amount */}
                        <div className="bg-gradient-to-r from-blue-600 to-cyan-600 rounded-xl p-4 text-white shadow-md">
                            <div className="flex justify-between items-center">
                                <span className="text-blue-50 text-sm font-medium">
                                    Số tiền cần chuyển
                                </span>
                                <span className="text-2xl font-bold">
                                    1.500.000.000 VND
                                </span>
                            </div>
                        </div>

                        {/* Transfer Content */}
                        <div className="bg-white dark:bg-gray-800 rounded-xl p-4 flex justify-between items-center">
                            <div className="flex-1">
                                <span className="text-xs text-gray-500 dark:text-gray-400 block mb-1">
                                    Nội dung chuyển khoản
                                </span>
                                <span className="font-semibold text-gray-900 dark:text-white text-sm">
                                    Thanh toan PIONEER
                                </span>
                            </div>
                            <button
                                type="button"
                                title="Sao chép nội dung chuyển khoản"
                                aria-label="Sao chép nội dung chuyển khoản"
                                className="ml-3 p-2 hover:bg-blue-50 dark:hover:bg-gray-700 rounded-lg transition-colors"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5 text-gray-400 dark:text-gray-500">
                                    <rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect>
                                    <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path>
                                </svg>
                            </button>
                        </div>
                    </div>

                    {/* QR Code Section */}
                    <div className="lg:col-span-1 flex flex-col items-center justify-center bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-2xl p-6">
                        <div className="mb-4">
                            <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center mx-auto mb-3 shadow-md">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6 text-white">
                                    <rect width="5" height="5" x="3" y="3" rx="1"></rect>
                                    <rect width="5" height="5" x="16" y="3" rx="1"></rect>
                                    <rect width="5" height="5" x="3" y="16" rx="1"></rect>
                                    <path d="M21 16h-3a2 2 0 0 0-2 2v3"></path>
                                    <path d="M21 21v.01"></path>
                                    <path d="M12 7v3a2 2 0 0 1-2 2H7"></path>
                                    <path d="M3 12h.01"></path>
                                    <path d="M12 3h.01"></path>
                                    <path d="M12 16v.01"></path>
                                    <path d="M16 12h1"></path>
                                    <path d="M21 12v.01"></path>
                                    <path d="M12 21v-1"></path>
                                </svg>
                            </div>
                            <p className="text-sm font-semibold text-gray-900 dark:text-white text-center">
                                Mã QR chuyển khoản
                            </p>
                            <p className="text-xs text-gray-500 dark:text-gray-400 text-center mt-1">
                                Quét để thanh toán nhanh
                            </p>
                        </div>

                        <div className="w-full aspect-square bg-gradient-to-br from-gray-100 to-gray-50 dark:from-gray-700 dark:to-gray-800 rounded-xl flex items-center justify-center border-2 border-gray-200 dark:border-gray-600 p-4">
                            <div className="w-full h-full bg-white dark:bg-gray-900 rounded-lg flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-32 w-32 text-gray-300 dark:text-gray-600">
                                    <rect width="5" height="5" x="3" y="3" rx="1"></rect>
                                    <rect width="5" height="5" x="16" y="3" rx="1"></rect>
                                    <rect width="5" height="5" x="3" y="16" rx="1"></rect>
                                    <path d="M21 16h-3a2 2 0 0 0-2 2v3"></path>
                                    <path d="M21 21v.01"></path>
                                    <path d="M12 7v3a2 2 0 0 1-2 2H7"></path>
                                    <path d="M3 12h.01"></path>
                                    <path d="M12 3h.01"></path>
                                    <path d="M12 16v.01"></path>
                                    <path d="M16 12h1"></path>
                                    <path d="M21 12v.01"></path>
                                    <path d="M12 21v-1"></path>
                                </svg>
                            </div>
                        </div>

                        <p className="text-xs text-gray-400 dark:text-gray-500 text-center mt-4">
                            Quét mã QR bằng app ngân hàng
                        </p>
                    </div>
                </div>
            </div>

            {/* Warning */}
            <div className="mt-6 flex items-start gap-3 text-sm text-amber-800 dark:text-amber-400 bg-gradient-to-br from-amber-50 to-orange-50 dark:from-amber-900/20 dark:to-orange-900/20 border border-amber-200 dark:border-amber-800 rounded-xl px-4 py-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5 flex-shrink-0 text-amber-600 dark:text-amber-500 mt-0.5">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" x2="12" y1="8" y2="12"></line>
                    <line x1="12" x2="12.01" y1="16" y2="16"></line>
                </svg>
                <div>
                    <p className="font-semibold mb-1">Lưu ý quan trọng:</p>
                    <p className="text-sm m-0">
                        Vui lòng chuyển khoản đúng số tiền và nội dung để hệ thống có thể xác nhận tự động nhanh chóng.
                    </p>
                </div>
            </div>

            {/* Upload Section */}
            <div className="mb-8">
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-6 flex items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6 text-blue-600 dark:text-cyan-500">
                        <rect width="18" height="18" x="3" y="3" rx="2" ry="2"></rect>
                        <circle cx="9" cy="9" r="2"></circle>
                        <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"></path>
                    </svg>
                    Upload biên lai thanh toán
                </h3>

                <div className="space-y-4">
                    {/* Upload Area */}
                    <label className="w-full border-2 border-dashed border-blue-200 dark:border-gray-700 rounded-2xl p-12 bg-gradient-to-br from-blue-50/30 to-cyan-50/30 dark:from-gray-800/30 dark:to-gray-900/30 flex flex-col items-center justify-center cursor-pointer hover:border-blue-400 dark:hover:border-blue-500 hover:bg-blue-50/50 dark:hover:bg-gray-800/50 transition-all group">
                        <div className="w-20 h-20 bg-white dark:bg-gray-800 rounded-2xl flex items-center justify-center mb-5 shadow-md group-hover:scale-105 transition-transform border border-gray-100 dark:border-gray-700">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-10 w-10 text-blue-600 dark:text-cyan-500">
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                <polyline points="17 8 12 3 7 8"></polyline>
                                <line x1="12" x2="12" y1="3" y2="15"></line>
                            </svg>
                        </div>

                        <p className="text-gray-900 dark:text-white font-bold text-lg mb-2">
                            Nhấn để chọn ảnh biên lai
                        </p>
                        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
                            Hỗ trợ PNG, JPG (tối đa 5MB)
                        </p>
                        <p className="text-xs text-gray-500 dark:text-gray-500 text-center max-w-md">
                            Chụp rõ ràng thông tin giao dịch, số tiền và nội dung chuyển khoản
                        </p>
                        <input type="file" accept="image/*" className="hidden" />
                    </label>

                    {/* Instructions */}
                    <div className="bg-gradient-to-br from-blue-50/50 to-white dark:from-gray-800 dark:to-gray-900 border border-blue-100 dark:border-gray-700 rounded-xl p-4">
                        <div className="flex items-start gap-3">
                            <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center flex-shrink-0 shadow-md">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5 text-white">
                                    <rect width="18" height="18" x="3" y="3" rx="2" ry="2"></rect>
                                    <circle cx="9" cy="9" r="2"></circle>
                                    <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"></path>
                                </svg>
                            </div>

                            <div className="flex-1">
                                <p className="font-semibold text-gray-900 dark:text-white mb-3 text-sm">
                                    Hướng dẫn chụp biên lai:
                                </p>
                                <ul className="space-y-2 text-sm text-gray-700 dark:text-gray-300">
                                    <li className="flex items-start gap-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4 text-blue-600 dark:text-cyan-500 flex-shrink-0 mt-0.5">
                                            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                            <path d="m9 11 3 3L22 4"></path>
                                        </svg>
                                        <span>Chụp toàn bộ màn hình giao dịch thành công</span>
                                    </li>

                                    <li className="flex items-start gap-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4 text-blue-600 dark:text-cyan-500 flex-shrink-0 mt-0.5">
                                            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                            <path d="m9 11 3 3L22 4"></path>
                                        </svg>
                                        <span>Đảm bảo rõ ràng: số tiền, nội dung, ngày giờ giao dịch</span>
                                    </li>

                                    <li className="flex items-start gap-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4 text-blue-600 dark:text-cyan-500 flex-shrink-0 mt-0.5">
                                            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                            <path d="m9 11 3 3L22 4"></path>
                                        </svg>
                                        <span>Không chỉnh sửa hoặc che mất thông tin quan trọng</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Action Buttons */}
            <div className="flex justify-between items-center w-full gap-5">
                <button
                    onClick={onBack}
                    className="w-1/2 h-11 px-5 py-2.5 bg-transparent border-2 border-gray-500 dark:border-gray-600 text-gray-500 dark:text-gray-400 rounded-xl cursor-pointer text-base transition-all hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-900 dark:hover:text-white"
                >
                    Quay lại
                </button>
                <button
                    onClick={onComplete}
                    className="w-[calc(50%+2px)] h-12 px-5 py-2.5 bg-gradient-to-r from-blue-600 to-blue-400 text-white rounded-xl cursor-pointer text-base transition-all hover:from-blue-700 hover:to-blue-500"
                >
                    Hoàn tất thanh toán
                </button>
            </div>
        </div>
    );
};

export default PlanPayment;
